<template>
  <div id="UploadExcel">
    <el-row>
      <el-col :span="24">
        <div class="excel-file-sample">
          <a href="https://docs.google.com/spreadsheets/d/1EuumJpNL6GsFt-AjtgoXMdMCybWcDlZBLrHTW4W3nHY/edit?usp=sharing" target="_blank">Sample Excel File Link</a>
        </div>
        <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
        <div class="drop gm-align-vertical-center" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
          <el-tooltip class="item" effect="dark" content="지도에 그릴 주소(필수), 목적지 이름(필수), 연락처(선택) 정보가 있는 Excel 파일을 업로드해주세요." placement="top" style="margin-left: auto; margin-right: 4px;">
            <vs-icon icon="info" color="primary"></vs-icon>
          </el-tooltip>
          Drop excel file
          <el-button :loading="loading" style="margin-left:8px; margin-right: auto;" size="mini" type="primary" @click="handleUpload">파일 선택
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import XLSX from 'xlsx'

export default {
  props: {
    beforeUpload: Function, // eslint-disable-line
    onSuccess: Function // eslint-disable-line
  },
  data() {
    return {
      loading: false,
      excelData: {
        header: null,
        body: null
      }
    }
  },
  methods: {
    generateData({ header, body }) {
      this.excelData.header = header
      this.excelData.body = body
      this.onSuccess && this.onSuccess(this.excelData)
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      if (this.loading) return
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$message.error('파일을 한 개만 올려주세요!')
        return
      }
      const rawFile = files[0] // only use files[0]

      if (!this.isExcel(rawFile)) {
        this.$message.error('.xlsx .xls .csv 확장자만 지원합니다.')
        return false
      }
      this.upload(rawFile)
      e.stopPropagation()
      e.preventDefault()
    },
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile)
    },
    upload(rawFile) {
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel

      if (!this.beforeUpload) {
        this.readerData(rawFile)
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.readerData(rawFile)
      }
    },
    readerData(rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const fixedData = this.fixData(data)
          const workbook = XLSX.read(btoa(fixedData), { type: 'base64' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const body = XLSX.utils.sheet_to_json(worksheet)
          this.generateData({ header, body })
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    fixData(data) {
      let o = ''
      let l = 0
      const w = 10240
      for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
      return o
    },
    getHeaderRow(sheet) {
      const header = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        header.push(hdr)
      }
      return header
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    }
  }
}

</script>
<style lang="scss" scoped>
#UploadExcel {
  .excel-upload-input {
    display: none;
    z-index: -9999;
  }

  .excel-file-sample {
    display: flex;
    margin-bottom: 8px;

    a {
      margin-left: auto;
      color: var(--danger-color);
    }
  }

  .drop {
    border: 2px dashed #bbb;
    height: 80px;
    line-height: 80px;
    margin: 0 auto;
    font-size: 16px;
    border-radius: 5px;
    text-align: center;
    color: #bbb;
    position: relative;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Util/UploadExcel/index.vue